import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const TwoCardsInRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 2rem;

	@media ${Breakpoints.tablet} {
		grid-template-columns: ${({ wideCharts }) => wideCharts && '1fr'};
	}

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
	}
`;

export const ThreeCardsInRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 2rem;

	@media ${Breakpoints.tablet} {
		grid-template-columns: 1fr 1fr;
	}

	@media ${Breakpoints.mobile} {
		grid-template-columns: 1fr;
	}
`;
